



















import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { TreasureBookModule } from '@/store/modules/treasureBook'

@Component({
    name: 'back-edit',
    components: {
    }
})
export default class BackEdit extends Vue {

    get devotionText() {
        return TreasureBookModule.dedication.text
    }

    get devotionTextSize() {
        return TreasureBookModule.dedication.size + "px";
    }

    get showBackground(){
        if(TreasureBookModule.dedication.text === ''){
            return 'none'
        }
        return 'block'
    }

    get coverType() {
        return TreasureBookModule.coverType
    }

    get showBackDetailText() {
        return TreasureBookModule.showBackDetailText
    }

    get inEditModeAndHasText() {
        return (this.showBackDetailText && TreasureBookModule.dedication.text.trim() !== "")
    }
}
